import { BaseBus } from "./BaseBus";

export class SubPOOrderInfo extends BaseBus {
    constructor(data: SubPOOrderInfo = null) {
        super(data);
    }
    orderId: any;
    changeOrderTotal: number;
    totalRetention: number;
    remainderToComplete: number;
    remainderToPay: number;
    totalBilled: number;
    totalCommitted: number;
    totalReleased: number;
}
